import React, { Component } from 'react';

/*Material ui template */
import TextField from '@material-ui/core/TextField';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';


//Para los select
// import MenuItem from '@material-ui/core/MenuItem';
// import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';

//switch requires
import purple from '@material-ui/core/colors/purple';
import Switch from '@material-ui/core/Switch';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import{ CREATE_PROJECT_MODEL_ACTION_CREATE } from '../common/redux/constantes';

const styles = theme => ({
  colorSwitchBase: {
    color: purple[300],
    '&$colorChecked': {
      color: purple[500],
      '& + $colorBar': {
        backgroundColor: purple[500],
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});

class ComponentInfo extends Component 
{

  state = {
    checkedB: true,
  };

  constructor(props)
  {
    super(props);
    //Bindings
    this.handleChangeSelectDeliverable=this.handleChangeSelectDeliverable.bind(this);
  }

  handleChange = name => event => 
  {
    this.setState({ [name]: event.target.checked });
  };
  
  handleChangeSelectDeliverable(val){
   this.props.handleChange({target:{value:val.value,id:'catalog'}}) 
  }


  getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }

  

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <DialogTitle id="form-dialog-title">Deliverable Information</DialogTitle>
         <DialogContent>
         { this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_CREATE?
         (
        <div>
         <InputLabel htmlFor="check_deliverable" style={{marginRight:'10px'}}>Select/Create</InputLabel>
           <Switch
            classes={{
              switchBase: classes.iOSSwitchBase,
              bar: classes.iOSBar,
              icon: classes.iOSIcon,
              iconChecked: classes.iOSIconChecked,
              checked: classes.iOSChecked,
            }}
            disableRipple
            checked={this.state.checkedB}
            onChange={this.handleChange('checkedB')}
            value="checkedB"
          />
        </div>
         ):null}
         
          {!this.state.checkedB || this.props.actionDialog!== CREATE_PROJECT_MODEL_ACTION_CREATE?(
            <TextField
              required
              id="name"
              name="Name"
              label="Name"
              fullWidth
              autoComplete="Name"
              value={this.props.deliverable.name || ''}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.deliverable.name}
              helperText={this.props.errores.deliverable.name}
            />
            ):(
            <div>
              <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Deliverable</InputLabel>
              <Select
                required
                id="catalog"
                name="catalog"
                value={this.getValueCatalog(this.props.deliverables,this.props.deliverable.catalog)}
                onChange={this.handleChangeSelectDeliverable}
                isDisabled={this.props.reviewActive}
                error={this.props.errores.deliverable.catalog}
                errorText={this.props.errores.deliverable.catalog}
                helperText={this.props.errores.deliverable.catalog}
                options={this.props.deliverables}
                styles={{control: (provided,state) => (this.props.errores.deliverable.catalog ? {...provided,borderColor: 'red', } : provided)}}
              >
              </Select>
            </div>
            )}
            
            <TextField
              style={{width: '100%', marginTop:'05%'}}
              id="description"
              label="Description"
              multiline
              rows="4"
              margin="normal"
              value={this.props.deliverable.description || ''}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.deliverable.description}
              helperText={this.props.errores.deliverable.description}
            />
          </DialogContent>
  </React.Fragment>
    );
  }
}



ComponentInfo.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ComponentInfo);


// WEBPACK FOOTER //
// ./src/features/wbs/DeliverableInfo.js